import io from 'socket.io-client';
let socket = undefined;
const listeners = [];
const localIP = 'localhost';
const networkIP = process.env.VUE_APP_NETWORK_IP_SOCKET;
const port = process.env.VUE_APP_PORT_SOCKET;

// true: connect to localhost
// false: connect to network
const localConnection = process.env.VUE_APP_NETWORK_LOCAL_CONNECTION;
const ssl = process.env.VUE_APP_WITH_SSL;
const socketEnable = process.env.VUE_APP_SOCKET_ENABLE;

// console.log(port)
// console.log(networkIP)
// console.log(typeof localConnection )

function initialiseSocket() {
  if (!socket) {
    let url;
    if(ssl==='true'){
      url = localConnection === 'true' ? 'https://' + localIP + ':' + port : 'https://' + networkIP + ':' + port;
    }else{
      url = localConnection === 'true' ? 'http://' + localIP + ':' + port : 'http://' + networkIP + ':' + port;
    }
    socket = io(url);
  }
}

export function addEventListener(event) {
  if(socketEnable === 'true'){
    initialiseSocket();

    if (!listeners.includes(event.type)) {
      socket.on(event.type, event.callback);
      listeners.push(event.type);
    }
  }
}

export function sendEvent(event) {
  if(socketEnable === 'true'){
    if (event.hasOwnProperty('data')) {
      socket.emit(event.type, event.data);
      return;
    }
    socket.emit(event.type);
  }
}
